import * as Types from '../../../../gql/__generated/graphql.types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { graphqlFetcher } from '@/modules/common/services/graphqlFetcher';
export type SeoMetaDataFragment = (
  { __typename?: 'SeoMetadata' }
  & Pick<Types.SeoMetadata, 'seoTitle' | 'description' | 'canonicalUrl' | 'noFollow' | 'noIndex' | 'schema'>
  & { shareImagesCollection?: Types.Maybe<(
    { __typename?: 'AssetCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'ContentfullAsset' }
      & Pick<Types.ContentfullAsset, 'url' | 'title'>
    )>> }
  )> }
);

export type SeoMetaDataBySlugQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SeoMetaDataBySlugQuery = (
  { __typename?: 'Query' }
  & { seoMetadataCollection?: Types.Maybe<(
    { __typename?: 'SeoMetadataCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'SeoMetadata' }
      & SeoMetaDataFragment
    )>> }
  )> }
);


export const SeoMetaDataFragmentDoc = `
    fragment SeoMetaData on SeoMetadata {
  seoTitle
  description
  canonicalUrl
  noFollow
  noIndex
  schema
  shareImagesCollection {
    items {
      url
      title
    }
  }
}
    `;
export const SeoMetaDataBySlugDocument = `
    query SeoMetaDataBySlug($slug: String) {
  seoMetadataCollection(where: {slug: $slug}) {
    items {
      ...SeoMetaData
    }
  }
}
    ${SeoMetaDataFragmentDoc}`;

export const useSeoMetaDataBySlugQuery = <
      TData = SeoMetaDataBySlugQuery,
      TError = unknown
    >(
      variables?: SeoMetaDataBySlugQueryVariables,
      options?: Omit<UseQueryOptions<SeoMetaDataBySlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SeoMetaDataBySlugQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SeoMetaDataBySlugQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SeoMetaDataBySlug'] : ['SeoMetaDataBySlug', variables],
    queryFn: graphqlFetcher<SeoMetaDataBySlugQuery, SeoMetaDataBySlugQueryVariables>(SeoMetaDataBySlugDocument, variables),
    ...options
  }
    )};

useSeoMetaDataBySlugQuery.getKey = (variables?: SeoMetaDataBySlugQueryVariables) => variables === undefined ? ['SeoMetaDataBySlug'] : ['SeoMetaDataBySlug', variables];


useSeoMetaDataBySlugQuery.fetcher = (variables?: SeoMetaDataBySlugQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<SeoMetaDataBySlugQuery, SeoMetaDataBySlugQueryVariables>(SeoMetaDataBySlugDocument, variables, options);
